<template>
  <div>
    <v-navigation-drawer fixed v-model="drawer" light app :width="250" v-if="!isMobileApp">
      
      <v-flex xs12 pt-3 text-xs-center>
        <v-avatar size="100px" color="grey lighten-4">
          <img src="../assets/images/face-icon.png" alt="avatar">
          <v-btn small absolute dark fab bottom icon color="pink" to="/profile" class="mb-2" style="height: 28px; width: 28px;"><v-icon small>edit</v-icon></v-btn>
        </v-avatar>
      </v-flex>

      <v-list class="pt-3 pb-3">
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title class="text-xs-center">{{fullname}}</v-list-tile-title>
            <v-list-tile-sub-title class="caption text-xs-center">{{role}}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <v-list class="pt-0 grey--text text--darken-3 sidebar-menu" dense>
        
        <v-divider></v-divider>
        
        <v-list-tile to="/dashboard">
          <v-list-tile-action>
            <v-icon>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Dashboard</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <!-- Modules Menu -->
        <div v-for="(menu, i) in $options.menus" :key="'menu-'+i" v-if="hasModuleAccess(i)">
          <!-- <v-divider></v-divider> -->
          <v-list-group no-action v-if="menu.pages" :prepend-icon="menu.icon">
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>{{menu.title}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-for="(page, j) in menu.pages" :to="menu.link + page.link" :key="'submenu-' + i + '-' + j" v-if="hasModuleAccess(j)">
              <v-list-tile-content>
                <v-list-tile-title>{{page.title}}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-icon>{{page.icon}}</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>

          <v-list-tile :to="menu.link" v-else>
            <v-list-tile-action>
              <v-icon>{{menu.icon}}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{menu.title}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

        </div>

        <!-- Modules Menu Ends -->

      </v-list>
    </v-navigation-drawer>
    <v-toolbar dense fixed app dark :class="$root.topbarBg" class="darken-2 elevation-0">
      <v-toolbar-side-icon @click.stop="drawer = !drawer" v-if="!isMobileApp"></v-toolbar-side-icon>
      <v-toolbar-title v-text="$options.title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-badge overlap color="red">
        <small slot="badge">3</small>
        <v-avatar color="transparent red--after" size="36">
          <v-icon>notifications</v-icon>
        </v-avatar>
      </v-badge>
      <v-badge overlap color="red" to="/dashboard">
        <small slot="badge">5</small>
        <v-avatar color="transparent red--after" size="36">
          <v-icon>email</v-icon>
        </v-avatar>
      </v-badge> -->
      <v-menu bottom left transition="slide-y-transition">
        <v-btn slot="activator" icon>
          <v-icon>person</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile to="/profile" px-5>
            <v-list-tile-action>
              <v-icon>person</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Profile</v-list-tile-title>
          </v-list-tile>
          <!-- <v-list-tile to="/settings" px-5>
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Settings</v-list-tile-title>
          </v-list-tile> -->
          <v-list-tile @click="logout" px-5>
            <v-list-tile-action>
              <v-icon>lock_open</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

    </v-toolbar>
  </div>
</template>

<script>

  import { title } from '../config/info'
  import menus from '../config/menu'
  import { removeSession } from '../helpers/session'

  export default {
    data () {
      return {
        drawer: !this.isMobileApp
      }
    },
    computed: {

      fullname () {
        let fullname = ""
        if (this.isLoggedIn) {
          fullname = this.loggedInUser.first_name
          if (this.loggedInUser.last_name) {
            fullname += " " + this.loggedInUser.last_name
          }
        }
        return fullname
      },

      role () {
        let role = ""
        if (this.isLoggedIn) {
          role = this.loggedInUser.role
        }
        return role
      },

    },
    created () {
      this.$options.title = title
      this.$options.menus = menus
    },
    methods: {
      logout: function(){
        this.axios.post("admin/logout")
          .then((response) => {

            this.notify('logoutSuccess', 'success')
            this.clearDataAndGo()
          })
          .catch((error) => {
            this.clearDataAndGo()
            console.log(error);
          });
      },
      clearDataAndGo: function(){
        this.$store.commit('setUser', {})
        this.$store.commit('setBreadcrumbs', [])
        removeSession('sessionId')
        removeSession('refreshToken')
        this.axios.defaults.headers.common[this.config.auth_header_key] = undefined //Authorization
        this.axios.defaults.headers.common[this.config.refresh_token_key] = undefined
        this.$router.push('/login')
      }
    }
  }
</script>
